module.exports = __webpack_public_path__ + "0bc8d252346e3745ed266b629df29e09.MP3";